export default "__VITE_ASSET__af$IBuMU__"